export default {
    // 韩语
    LOCALE_HTML: {
        'msg.language': '韩语',
        'msg.title': '표제',
        'msg.type': '문제 분류',
        'msg.des': '문제 설명',
        'msg.phone': '휴대폰 전화번호',
        'msg.regionCode': '지역 코드',
        'msg.email': '메일박스',
        'msg.choose': '구분을 선택하세요.',
        'msg.detail': '댓글 상세 정보',
        'msg.back': '되돌아갑니다.',
        'your.msg': '댓글을 달아주세요.',
        'msg.record': '댓글 기록',
        'msg.success': '댓글 성공',
        'to.record': '댓글 기록에 갑니다.',
        completed: '완성',
        submit: '제기',
        'success.desc': '댓글이 성공적으로 제출되었습니다, 감사합니다.',
        'msg.form.input': '입력하세요.',
        'msg.reply': '리세트',
        'comment.suc': '평가해 주셔서 감사합니다！',
        'comment.fail': '제출 실패',
        'comment.placeholder': '우리의 서비스에 건의를 한 것을 환영합니다.',
        'reply.suc': '제출 성공!',
        'reply.fail': '답장을 입력하세요.',
        'reply.placeholder': '답장을 입력하세요.',
        'msg.more': '더 보기',
        'msg.collapse': '중지합니다.',
        'msg.myservice': '제 서비스 평가',
        'msg.evaluate': '서비스 평가',
        'msg.evaluateTitle': '서비스 평가',
        'msg.score': '평점',
        'msg.remark': '평어',
        'msg.status.created': '생성됨',
        'msg.status.pending': '접수 대기',
        'msg.status.processing': '접수중',
        'msg.status.solved': '완성됩니다.',
        'msg.service.reply': '고객 서비스 답장',
        'msg.my.reply': '당신의 답장',
        'msg.toast.des': '문제 설명이 비어 있음.',
        'msg.toast.type': '문제 분류가 비어 있음.',
        'msg.toast.title': '문제가 비어 있음.',
        'msg.toast.none': '비워둘 수 없습니다.',
        'msg.toast.noAnnex': '첨부파일을 올려주세요.',
        'msg.toast.noEmail': '메일 박스를 비워둘 수 없습니다.',
        'msg.toast.noTel': '휴대폰 전화번호를 비워둘 수 없습니다.',
        'msg.toast.noRegionCode': '지역번호는 비워둘 수 없습니다.',
        'msg.toast.noZone': '시간대를 선택하세요.',
        'msg.toast.noDateTime': '날짜 시간을 선택하세요.',
        'msg.toast.email': '정확한 메일박스를 기입하세요.',
        'msg.toast.tel': '정확한 휴대전화 번호를 기입하세요.',
        'msg.toast.regionCode': '지역번호를 선택해주세요',
        'msg.toast.num': '정확한 숫자를 기입하세요.',
        'msg.toast.annex': '첨부파일을 올려주세요.',
        'msg.toast.char': '정확한 문자 부호를 입력해 주세요.',
        'msg.list.none': '데이터가 없습니다.',
        'msg.form.choose': '선택하세요.',
        'msg.form.chooseZone': '시간대 선택',
        'msg.form.chooseTime': '시간 선택',
        'msg.form.chooseDate': '날짜 선택',
        'msg.form.sure': '확정',
        'msg.form.search': '검색...',
        'msg.form.uploadError': '실격',
        'msg.form.uploadXss': '업로드 실패, 파일 콘텐츠에 불법 스크립트 포함',
        'msg.update.time': '에 업데이트됨',
        'msg.replace.images': '그림',

        MSG016: '해결',
        MSG017: '미해결',
        MSG019: '제출하다',
        MSG072: '평가 라벨은 비워둘 수 없습니다! ',
        MSG073: '평가 언어는 비워둘 수 없습니다! ',
        MSG074: '상표:',
        MSG075: '해결되었나요:',
        MSG076: '문제가 해결되었는지 선택하세요.',
        MSG015: '이 티켓으로 문제가 해결되었나요?',

        'file.size.limit': '파일 크기가 50MB를 초과할 수 없습니다.',
        'detail.file.limit': '최대 15개, 50MB 이상 크면 안됩니다.',
        'form.question.des.tip': '문제 설명을 입력하세요.',
        'form.title.tip': '표제를 입력하세요.',
        'form.class.tip': '문제 분류를 선택하세요.',
        'upload.file': '첨부파일 올립니다.',
        'file.count.limit': '첨부 파일 최대 15개까지만 업로드 가능합니다.',
        'select.search.placeholder': '키워드 검색',
        'msg.form.sizeError1': '5M보다 작은 첨부파일을 올려주세요.',
        'msg.form.sizeError2': '50M보다 작은 첨부파일을 올려주세요.',
        'msg.form.submit': '제출중...',
        'msg.form.upload': '업로드 중…',
        'msg.email.tip1': '당신의 메모를 조회하지 못했습니다.',
        'msg.email.tip2':
            '만약 이전에 메시지를 남긴 적이 있다면, 메일 인증으로 확인하실 수 있습니다.',
        'msg.email.tip3': '메일 인증 시작합니다.',
        'msg.email.noData': '현재 계정 번호 아래 데이터가 없습니다.',
        'email.verify.tip': '댓글 입력 시 사용할 이메일 주소를 입력하세요.',
        'email.input.placeholder': '이메일 주소를 입력해주세요.',
        'email.submit': '이메일을 발송합니다.',
        'email.rules.error': '정확한 이메일을 입력해주세요.',
        'email.code.tip': '메일이 발송되었습니다, 받은 인증 번호를 입력하세요.',
        'email.code.placeholder': '인증 번호를 입력하세요.',
        'email.code.submit': '바로 보기',
        'email.notFind.customer': '고객정보가 조회되지 않았습니다.',
        'email.code.wrong': '인증번호가 잘못되었습니다, 다시 입력해주세요.',
        'email.code.expired':
            '인증번호가 만료되었습니다, 이메일 다시 확인해주세요.',
        'email.code': '인증번호',
        'email.send.frequently':
            '작업이 너무 잦습니다. 나중에 다시 시도해 주세요.',
        'comment.fail.400133': '이 티켓은 평가되었습니다',
        'not.get.user.info': '정보를 가져올 수 없습니다.',
        'user.verify.tip': '메시지 목록 내용을 보려면 인증을 통과해야 합니다.',
        'verify.type.email': '메일박스 인증',
        'verify.text': '검증',
        'cancel.text': '취소',
        'get.verify.code': '인증 코드 가져오기',
        'reGet.verify.code': '다시 가져오기 ',
        'verify.by.email.tip':
            '인증번호는 입력하신 이메일 계정으로 이메일로 전송됩니다.',
        'verify.type.phone': '문자 확인',
        'phone.placeholder': '핸드폰 번호를 입력하세요.',
        'verify.by.phone.tip':
            '인증번호는 입력한 휴대폰 번호로 문자 메시지로 전송됩니다.',
        'phone.error': '정확한 핸드폰 번호를 입력하세요.',
        'phone.errorCode400150': '인증 코드가 자주 전송됨',
        'phone.errorCode400233': '메시지 템플릿은 비워둘 수 없습니다.',
        'phone.errorCode400234': '마케팅 문자 잔액 부족',
        'phone.errorCode400235': '알림 문자 잔액 부족',
        'phone.errorCode400247': '작업 명세서 플러그인 문자 메시지 설정 오류',
        'phone.errorCode4400248': '메시지 템플릿 가져오기 실패',
        'phone.errorCode400249':
            '이 번호 는 기존 사용자 의 핸드폰 번호 가 아니다',
        'phone.errorCode400250':
            '인증 코드가 만료되었습니다. 다시 가져오십시오.',
        'msg.you.reply': '당신에게 답장을 보냈습니다',
        'msg.no.reply':'답변 없음',
    },
    LOCALE_REQUEST: {
        400016: '작업 주문 정보 획득이 만료되었습니다. 새로고침하세요!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: '삭제',
                cancel: '취소',
                confirm: '결정',
                inert: '삽입',
                width: '너비',
                height: '높이'
            },
            controls: {
                clear: '콘텐츠지우기',
                undo: '취소',
                redo: '다시하기',
                fontSize: '글자크기',
                lineHeight: '행높이',
                letterSpacing: '단어간격',
                textIndent: '단락들여쓰기',
                increaseIndent: '들여쓰기늘리기',
                decreaseIndent: '들여쓰기줄이기',
                border: '국경',
                color: '색상',
                textColor: '텍스트색상',
                backgroundColor: '배경색상',
                tempColors: '임시색',
                bold: '굵게',
                italic: '기울임꼴',
                underline: '밑줄',
                strikeThrough: '취소선',
                fontFamily: '글꼴',
                textAlign: '텍스트정렬',
                alignLeft: '왼쪽',
                alignCenter: '중심',
                alignRight: '오른쪽',
                alignJustify: '양쪽끝',
                floatLeft: '떠다니기',
                floatRight: '오른쪽부동',
                superScript: '위첨자',
                subScript: '첨자',
                removeStyles: '스타일지우기',
                headings: '제목',
                header: '제목',
                normal: '재래식',
                orderedList: '순서가지정된목록',
                unorderedList: '정렬되지않은목록',
                blockQuote: '참고문헌',
                code: '코드',
                link: '링크',
                unlink: '링크삭제',
                hr: '수평선',
                media: '미디어',
                mediaLibirary: '미디어라이브러리',
                emoji: '작은표현',
                fullscreen: '전체화면',
                exitFullscreen: '전체화면종료'
            },
            linkEditor: {
                textInputPlaceHolder: '링크텍스트입력',
                linkInputPlaceHolder: '링크주소입력',
                inputWithEnterPlaceHolder: '링크주소입력.',
                openInNewWindow: '새창열기',
                removeLink: '링크삭제'
            },
            audioPlayer: {
                title: '오디오파일재생'
            },
            videoPlayer: {
                title: '비디오파일재생',
                embedTitle: '임베디드미디어'
            },
            media: {
                image: '이미지',
                video: '비디오',
                audio: '오디오',
                embed: '임베디드미디어'
            }
        },
        finder: {
            remove: '삭제',
            cancel: '취소',
            confirm: '확인',
            insert: '선택한항목삽입',
            width: '너비',
            height: '높이',
            image: '그림',
            video: '비디오',
            audio: '오디오',
            embed: '임베디드미디어',
            caption: '미디어라이브러리',
            dragTip: '파일을 클릭하거나이 지점으로 드래그하십시오.',
            dropTip: '업로드하려면마우스를놓으십시오.',
            selectAll: '모두 선택',
            deselect: '선택 취소',
            removeSelected: '선택한 항목 삭제',
            externalInputPlaceHolder: '리소스 이름 | 리소스 주소',
            externalInputTip: '자원 이름과 자원 주소를 "|"',
            addLocalFile: '로컬 리소스 추가',
            addExternalSource: '네트워크 리소스 추가',
            unnamedItem: '이름없는 항목',
            confirmInsert: '선택한 항목 삽입'
        }
    }
}
